<article class="project-card tutorial-project-card" [ngClass]="{'project-card--archived': isArchived}">
  <div class="project-top">
    <div>
      <div class="project-label">Project</div>
      <h3>
        {{ project.name }}
        <img *ngIf="deleteProjectInProgress || archiveProjectInProgress" src="../../../assets/loading-indicator.svg" alt="Updating project">
      </h3>

      <div class="project-meta">
        <span *ngIf="isArchived" class="archived-pill">
          <i class="fa fa-archive" aria-hidden="true"></i>
          Archived (locked)
        </span>
        <span>
          <i class="fa fa-users" aria-hidden="true"></i>
          {{ getMemberCount() }} {{ getMemberLabel() }}
        </span>
        <span class="meta-divider">•</span>
        <span>
          <i class="fa fa-file-audio-o" aria-hidden="true"></i>
          {{ getRecordingCount() }} recordings
        </span>
      </div>
    </div>

    <div class="project-menu" (mouseover)="showProjectMenu(true)" (mouseout)="showProjectMenu(false, true)">
      <button class="menu-button" aria-label="Project actions">
        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
      </button>

      <ul *ngIf="projectMenuVisible" class="project-menu-dropdown">
        <li *ngIf="!isArchived && canCreateInviteCodes" (click)="showInviteCodesDialog()"><i class="fa fa-envelope" aria-hidden="true"></i> Invitation codes</li>
        <li *ngIf="!isArchived" (click)="archiveProject()"><i class="fa fa-archive" aria-hidden="true"></i> Archive project</li>
        <li *ngIf="isArchived" (click)="unarchiveProject()"><i class="fa fa-unlock" aria-hidden="true"></i> Unarchive project</li>
        <li *ngIf="!isArchived" (click)="deleteProject()"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete project</li>
      </ul>
    </div>
  </div>

  <ng-container *ngIf="!isArchived; else archivedProjectBody">
    <div class="project-body two-col">
      <section class="app-column tutorial-project-applications">
        <div class="subsection-head">
          <div>
            <h4>Applications</h4>
            <p>Work with your material through different applications.</p>
          </div>
        </div>

        <div class="tile-list application-list">
          <app-appctrl *ngFor="let vispApp of vispApplications" [vispApp]="vispApp" [project]="project" [projectItem]="this"></app-appctrl>
        </div>
      </section>

      <section class="ops-column tutorial-project-operations">
        <div class="subsection-head">
          <div>
            <h4>Operations</h4>
            <p>Manage workflow and project resources.</p>
          </div>
        </div>

        <div class="tile-list">
          <button class="tool-tile" (click)="transcribeDialog(this.project)">
            <span class="tile-icon neutral"><i class="fa fa-file-text-o" aria-hidden="true"></i></span>
            <span class="tile-copy">
              <span class="tile-label">Auto-transcribe</span>
              <span class="tile-subtitle">Powered by WhisperX</span>
            </span>
            <i class="fa fa-chevron-right tile-chevron" aria-hidden="true"></i>
          </button>

          <button class="tool-tile" (click)="editEmuDb(this.project)">
            <span class="tile-icon neutral"><i class="fa fa-microphone" aria-hidden="true"></i></span>
            <span class="tile-copy">
              <span class="tile-label">Recording sessions</span>
              <span class="tile-subtitle">View and manage recorded audio files</span>
            </span>
            <i class="fa fa-chevron-right tile-chevron" aria-hidden="true"></i>
          </button>

          <button class="tool-tile" (click)="manageBundleLists(this.project)">
            <span class="tile-icon neutral"><i class="fa fa-headphones" aria-hidden="true"></i></span>
            <span class="tile-copy">
              <span class="tile-label">Assign annotation tasks</span>
              <span class="tile-subtitle">Distribute bundles for annotation in Artic</span>
            </span>
            <i class="fa fa-chevron-right tile-chevron" aria-hidden="true"></i>
          </button>

          <button class="tool-tile" (click)="manageMembers(this.project)">
            <span class="tile-icon neutral"><i class="fa fa-users" aria-hidden="true"></i></span>
            <span class="tile-copy">
              <span class="tile-label">Members</span>
              <span class="tile-subtitle">Manage team members and roles</span>
            </span>
            <i class="fa fa-chevron-right tile-chevron" aria-hidden="true"></i>
          </button>

          <button class="tool-tile" (click)="openSprScriptsDialog(this.project)">
            <span class="tile-icon neutral"><i class="fa fa-list-ol" aria-hidden="true"></i></span>
            <span class="tile-copy">
              <span class="tile-label">Manage recording scripts</span>
              <span class="tile-subtitle">Create and edit speaker prompts</span>
            </span>
            <i class="fa fa-chevron-right tile-chevron" aria-hidden="true"></i>
          </button>
        </div>
      </section>
    </div>
  </ng-container>

  <ng-template #archivedProjectBody>
    <div class="project-body archived-project-body">
      <p>
        This project is archived. It is locked for all changes and session launches until you unarchive it from the project menu.
      </p>
    </div>
  </ng-template>
</article>
